/** Issuer URLs compare equal regardless of surrounding whitespace and trailing slashes. */
export function normalizeIssuer(issuer: string): string {
  return issuer.trim().replace(/\/+$/, "");
}
